module.exports = __webpack_public_path__ + "media/images/logo100_White-049b550991267502eb6c01dfac36bb08.png";